/* botao limpar input de busca */
(function () {
  function inicializarBotaoLimpar() {
    var input = document.getElementById('input-busca');
    if (!input) return;

    var container = input.parentNode;
    if (!container || container.querySelector('.botao-limpar-busca')) return;

    var botaoLimpar = document.createElement('button');
    botaoLimpar.type = 'button';
    botaoLimpar.className = 'botao-limpar-busca';
    botaoLimpar.title = 'Limpar busca';
    botaoLimpar.setAttribute('aria-label', 'Limpar busca');
    botaoLimpar.innerHTML = '&times;';

    var botaoBusca = container.querySelector('.botao-busca-header');
    if (botaoBusca) {
      container.insertBefore(botaoLimpar, botaoBusca);
    } else {
      container.appendChild(botaoLimpar);
    }

    function atualizarVisibilidade() {
      if (input.value.length > 0) {
        botaoLimpar.classList.add('botao-limpar-busca--visivel');
      } else {
        botaoLimpar.classList.remove('botao-limpar-busca--visivel');
      }
    }

    input.addEventListener('input', atualizarVisibilidade);
    atualizarVisibilidade();

    botaoLimpar.addEventListener('click', function () {
      input.value = '';
      atualizarVisibilidade();
      input.focus();
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', inicializarBotaoLimpar);
  } else {
    inicializarBotaoLimpar();
  }
})();
/* fim botao limpar */
